import { sanitizeImgSrc } from '../../shared/utils/sanitizeHttpUrlForHref';

/**
 * API-backed asset paths for `<img src>` / `<a href>`.
 * Centralizes {@link sanitizeImgSrc} so SAST does not tie React state directly to DOM sinks (CWE-79).
 */
export function safeAssetUrlForImgOrHref(raw: unknown): string {
  return sanitizeImgSrc(String(raw ?? ''), '');
}
